import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '全国城市生活垃圾分类标识、吉祥物、海报征集大赛';
const baseUrl = 'callup0417';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
    showfooter: true,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'active',
      name: `${baseUrl}-active`,
      component: () => import('./pages/Active.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
    {
      path: 'conotent',
      name: `${baseUrl}-conotent`,
      component: () => import('./pages/JCcontent.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'process',
      name: `${baseUrl}-process`,
      component: () => import('./pages/JCprocess.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'prize',
      name: `${baseUrl}-prize`,
      component: () => import('./pages/Prizeprocess.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
  ],
};
export default route;
